import api from '@/util/app-api'

class AuthService {
  login (user) {
    return api
      .post('api/token', {
        username: user.username,
        password: user.password,
      }, { authHeader: false, contentType: 'application/x-www-form-urlencoded;charset=utf-8' })
      .then(
        response => {
          if (response.accessToken) {
            response.createAt = new Date()
            localStorage.setItem('user', JSON.stringify(response))
          }
          return response
        })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  otpLogin (data) {
    return api
      .post('account/OTPToken', {
        mobile: data.mobile,
        OTPCode: data.otpCode,
        customerCode: data.customerCode,
        role: data.role
      }, { authHeader: false, contentType: 'application/x-www-form-urlencoded;charset=utf-8' })
      .then(
        response => {
          if (response.jwtToken?.accessToken) {
            response.jwtToken.createAt = new Date()
            localStorage.setItem('user', JSON.stringify(response.jwtToken))
          }
          return response
        })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  logout () {
    localStorage.removeItem('user')
  }

  register (user) {
    return api.post('signup', {
      username: user.username,
      email: user.email,
      password: user.password,
    })
  }

  getUserClaim (user) {
    return api.get('admin/user/GetClaims/'+user.id)
  }
}

export default new AuthService()
